<template>
  <div class="input-select weight-select d-block clear-float" v-on-clickaway="closeSelect">
    <label
      v-if="label"
      @click="closeSelect">{{ label }} <span v-if="rules.required" class="warning-color">*</span></label>
    <div class="input-holder">
      <input
        tabindex="2"
        :class="{required: localShouldShowError}"
        class="input-left"
        :value="value.value"
        @focus="$emit('focus')"
        @input="changeValue($event.target.value)" />
    </div>
    <div
      @click="openListOnClick"
      tabindex="0"
      @focus="openListOnFocus"
      class="input-like absolute float-left">
      <span v-if="value.unit === ''">Select option</span>
      <span class="uppercase dark-text" v-else>{{ value.unit }}</span>
      <Icon
        class="icon"
        name="arrowDown"
        size="28" />
    </div>
    <span v-if="localShouldShowError" class="warning-color validation-span" style="font-size: 12px;">{{ $t(errorMsg) }} {{ errorMsgAdditional }}</span>
    <div v-show="isListOpened" class="options-list">
      <input
        ref="searchField"
        class="search"
        v-model="search"
        @keydown="searchIt"
        :placeholder="$t('Search...')" />
      <ul>
        <li
          @keydown.prevent="nextItem"
          tabIndex="-1"
          v-for="(item, index) in filteredList"
          :key="`option-${index}`"
          :ref="`${randomSelectId}-${index}-opt`"
          class="uppercase"
          :class="{active: indexItem === index}"
          @click="changeUnit(index, item)">
          {{ item.text }}
          <input :value="item.value.unit" type="checkbox" style="display: none;"/>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { directive as onClickaway } from 'vue-clickaway';
import currencyList from '@/data/currency.js';
import mixin from '@/mixins/mixins.js';
import rules from "@/mixins/rules";

export default {
  name: 'CurrencySelect',
  directives: {
    onClickaway: onClickaway,
  },
  mixins: [mixin, rules],
  props: {
    placeholder: {
      type: String,
      default: 'Select option',
    },
    label: {
      type: String,
      default: '',
    },
    value: {
      type: Object,
      default: () => {
        return{
          value: '',
          unit: 'eur',
        }
      },
    },
  },
  data() {
    return {
      indexItem: 0,
      isListOpened: false,
      openedOnClick: false,
      search: '',
    };
  },
  computed: {
    filteredList() {
      return this.currencyList.filter(option => {
        return option.text.toLowerCase().includes(this.search.toLowerCase());
      });
    },
    currencyList() {
      const array = [];
      Object.keys(currencyList).forEach((key, index) => {
        array.push({
          text: key,
          value: key,
        });
      });
      return array;
    },
    randomSelectId() {
      return `select-${this.randomNumber()}`
    },
    localShouldShowError() {
      return this.externValidate(this.value.value)
    }
  },
  methods: {
    searchIt(event) {
      if(event.keyCode == 9) this.closeSelect();
      if (event.keyCode == 38 || event.keyCode == 40) {
      	this.nextItem(event);
      } else {
        this.indexItem = 0;
        this.search = event.target.value;
      }
    },
    nextItem (event) {
      if(event.keyCode == 9) this.closeSelect();
    	if (event.keyCode == 38 && this.indexItem > 0) {
      	this.indexItem--;
        this.$refs[`${this.randomSelectId}-${this.indexItem}-opt`][0].focus();
      } else if (event.keyCode == 40 && this.indexItem < this.filteredList.length - 1) {
      	this.indexItem++;
        this.$refs[`${this.randomSelectId}-${this.indexItem}-opt`][0].focus();
      } else if (event.keyCode == 13) {
      	this.$refs[`${this.randomSelectId}-${this.indexItem}-opt`][0].click();
      }
    },
    randomNumber() {
      return Math.floor(100000 + Math.random() * 900000);
    },
    changeUnit(index, option) {
      this.isListOpened = false;
      this.openedOnClick = false;
      this.indexItem = index;
      this.$emit('input', {
        value: this.value.value,
        unit: option.value,
      });
      this.search = '';
    },
    changeValue(val) {
      this.isListOpened = false;
      this.openedOnClick = false;
      this.$emit('input', {
        value: val,
        unit: this.value.unit,
      });
    },
    closeSelect() {
      this.isListOpened = false;
      this.openedOnClick = false;
      this.search = '';
    },
    openListOnClick() {
      if(this.openedOnClick) {
        this.closeSelect();
        return;
      }
      this.isListOpened = true;
      this.openedOnClick = true;
      this.currencyList.filter((opt, index) => {
        if(opt.value == this.value.unit) this.indexItem = index;
      });
      this.$nextTick(() => {
        this.$refs[`${this.randomSelectId}-${this.indexItem}-opt`][0].focus();
        this.$refs.searchField.focus();
      });
    },
    openListOnFocus() {
      this.isListOpened = true;
      this.currencyList.filter((opt, index) => {
        if(opt.value == this.value.unit) this.indexItem = index;
      });
      this.$nextTick(() => {
        this.$refs[`${this.randomSelectId}-${this.indexItem}-opt`][0].focus();
        this.$refs.searchField.focus();
      });
    },
  },
}
</script>

